import { AsyncGridColumns, ColumnDate } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: '№',
    field: 'serialNumber',
    sortable: false,
    width: 100,
  },
  {
    headerName: 'column.order of debits',
    field: 'workSchedule',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.time of debit',
    field: 'time',
    sortable: false,
    renderCell: ({ row }) => <ColumnDate type='time' value={row.time} />,
    width: 150,
  },
  {
    headerName: 'column.amount',
    field: 'cost',
    sortable: false,
    flex: 1,
  },
]
